<template>
  <div class="app flex-row align-items-center">
     <loader :show="enviando"/>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="ingresar">
                  <h1>Iniciar sesión</h1>
                  <p class="text-muted">Ingrese sus datos:</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                        class="form-control" 
                        placeholder="Código" 
                        autocomplete="username"
                        :class="{invalid_input: $v.codigo.$error}"
                        autofocus
                        v-model.trim="codigo"
                        :disabled="submitStatus === 'PENDING'" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                        class="form-control" 
                        placeholder="Contraseña" 
                        autocomplete="current-password" 
                        :class="{invalid_input: $v.password.$error}"
                        v-model="password"
                        :disabled="submitStatus === 'PENDING'"/>
                  </b-input-group>
                  <b-form-checkbox id="checkbox1"
                                  v-model="checkbox">
                    Mantener sesión abierta
                  </b-form-checkbox>
                  <b-row>
                    <b-col cols="12">
                      <p v-if="!$v.codigo.required && inputErrors" class="errorMessage">Código requerido</p>
                      <p v-if="!$v.password.required && inputErrors" class="errorMessage">Contraseña requerida</p>
                      <p v-if="!inputErrors" class="errorMessage">{{ errorMessage }}  </p>
                      <p> {{ mensaje }}  </p>
                    </b-col>
                    <b-col cols="6">
                      <b-button type="submit" variant="secondary" class="px-4">Ingresar</b-button>
                    </b-col>
                    <!-- <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Olvidé mi contraseña</b-button>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white" style="width:44%">
              <b-card-body class="text-center">
                  <img class="navbar-brand-full" src="img/brand/logo2124.png" width="70%"  alt="System Logo">
              </b-card-body>
              <b-card-body class="text-center">
                <b-button variant="secondary" size="sm" href="https://webmail.elsalto.gob.mx" target="_self">
                  <i class="fa fa-envelope"></i>
                  Correo institucional
                </b-button>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import { required} from 'vuelidate/lib/validators'
import axios from 'axios'
import Loader from '../Loader'
import { mapGetters } from "vuex";

export default {
  name: 'Login',
  components: {
    Loader
  },
  computed: {
      ...mapGetters([
        "httpURL",
        "sessionToken"
      ])
  },
  data(){
      return{
        codigo: '',
        password : '',
        submitStatus: '',
        inputErrors: false,
        errorMessage : '',
        mensaje: '',
        enviando: false,
        checkbox: false
      }
    },
    validations: {
      codigo:{
          required
      },
      password: {
          required
      }
    },
    methods: {
        ingresar: function(){
            //console.log('Ingresando');
            this.mensaje = 'Ingresando...';
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.inputErrors = true
                this.mensaje = '';
            } else {
                this.enviando = true;
                this.inputErrors = false;
                this.submitStatus = 'PENDING';
                axios.post(this.httpURL+'/login',{
                    codigo: this.codigo,
                    password: this.password
                })
                .then(res => {
                   //console.log(res);
                    let token = res.data.token;
                    if( res.data.ok ){
                      this.mensaje = 'Autenticado correctamente';
                      this.checkbox ? localStorage.setItem("token",token) : sessionStorage.setItem("token",token);
                      this.$router.push('/inicio');
                    }else{
                      this.errorMessage = res.data.mensaje;
                      this.mensaje = '';
                      this.submitStatus = '';
                    }
                    this.enviando = false;
                })
                .catch(error => {
                    //console.log(error);
                    this.mensaje = '';
                    this.enviando = false;
                    this.submitStatus = '';
                    this.errorMessage = 'Ocurrió un error ';
                });
                
            }
        }
    },
  created() {
    if( sessionStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
    if( localStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", localStorage.getItem("token"));

      if( this.sessionToken ){
        this.enviando = true;
        axios.get(this.httpURL+'/login',{headers:{token:this.sessionToken}})
              .then(res => {
                if(res.data.ok){
                  this.$router.push('/inicio');
                  this.enviando = false;
                }
               
              })
              .catch(error => {
                  this.enviando = false;
                  //console.log('Error: '+error);
                  // if(error.response)
                  //   this.$router.push('/login');
              });
      }
    }
}
</script>

<style>
.errorMessage {
    color: #FF0000
}
.invalid_input{
    border: 1px solid red;
}
</style>
